<template>
  <a-card :bordered="false">
    <div v-if="isShowIndex">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="名称">
                <a-input placeholder="请输入名称" v-model="fileName"></a-input>
              </a-form-item>
            </a-col>

            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span
                style="float: left; overflow: hidden"
                class="table-page-search-submitButtons"
              >
                <a-button type="primary" @click="searchQuery" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
              </span>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="季报文件">
                <a-button @click="showDialog = true">
                  <a-icon type="upload" /> 导入
                </a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->

      <!-- table区域-begin -->
      <div>
        <!-- 导入 -->
        <a-modal
          title="上传文件"
          :visible="showDialog"
          @cancel="showDialog = false"
        >
          <a-upload-dragger
            name="file"
            :multiple="true"
            :file-list="fileList"
            accept=".zip,.rar"
            :before-upload="beforeUpload"
            :remove="handleRemove"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">点击或拖拽上传文件</p>
          </a-upload-dragger>

          <template slot="footer">
            <a-button key="back" @click="showDialog = false"> 取消 </a-button>
            <a-button
              :disabled="fileList.length === 0"
              :loading="uploading"
              key="submit"
              type="primary"
              icon="download"
              @click="upload"
            >
              导入
            </a-button>
          </template>
        </a-modal>

        <a-table
          ref="table"
          :scroll="{ x: 1150 }"
          bordered
          rowKey="fundCode"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          class="j-table-force-nowrap"
          @change="handleTableChange"
        >
          <template slot="publishStatus" slot-scope="text, record">
            <a-switch
              v-model="record.statusFlg"
              checked-children="已发布"
              un-checked-children="未发布"
              :disabled="record.checkStatus == 1 ? false : true"
              @click="checked => handlePublish(checked, record)"
            />
          </template>
          <span slot="action" slot-scope="text, record">
            <a @click="handleFiveBonds(record, 1, 'fiveBondsModel')"
              >五大债券</a
            >
            <a-divider type="vertical" />
            <a @click="handleFiveBonds(record, 2, 'tenStocksModel')"
              >十大股票</a
            >
            <a-divider type="vertical" />
            <a @click="handleFiveBonds(record, 3, 'distributionModel')"
              >行业分布</a
            >
            <a-divider type="vertical" />
            <a @click="handleFiveBonds(record, 4, 'portfolioModel')"
              >资产组合</a
            >
            <a-divider type="vertical" />

            <a
              @click="reviewDetails(record)"
              :disabled="record.checkStatus == 1 ? true : false"
              >审核</a
            >
          </span>
        </a-table>
      </div>
    </div>
    <a-modal
      title="审核"
      :visible="showReview"
      :width="800"
      @cancel="showReview = false"
      @ok="handalExamine"
    >
      <a-radio-group v-model="examineFlg" @change="examineFlgChange">
        <a-radio :value="1">审核通过</a-radio>
        <a-radio :value="2">审核驳回</a-radio>
      </a-radio-group>
      <a-textarea
        style="margin-top: 20px"
        placeholder="请输入理由"
        v-model="reason"
        :max-length="100"
        :auto-size="{ minRows: 2, maxRows: 6 }"
      />
    </a-modal>
    <fiveBonds
      v-if="isFiveBonds"
      ref="fiveBondsModel"
      @handelColse="handelColse"
    ></fiveBonds>
    <tenStocks
      v-if="isTenStocks"
      @handelColse="handelColse"
      ref="tenStocksModel"
    ></tenStocks>
    <distribution
      v-if="isDistribution"
      ref="distributionModel"
      @handelColse="handelColse"
    ></distribution>
    <portfolio
      v-if="isPortfolio"
      ref="portfolioModel"
      @handelColse="handelColse"
    ></portfolio>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import fiveBonds from './module/fiveBond.vue';
import tenStocks from './module/tenStocks.vue';
import portfolio from './module/portfolio.vue';
import distribution from './module/distribution.vue';
import { uploadAction, getAction } from '@/api/manage';
import { postTag, postAction } from '../../../api/manage';
export default {
  name: 'FiveBonds',
  components: {
    fiveBonds,
    tenStocks,
    distribution,
    portfolio
  },
  data() {
    return {
      showReview: false,
      fileName: '', //名称查询
      isPortfolio: false, //资产组合
      isDistribution: false, //行业分布
      isTenStocks: false, //十大股票
      isShowIndex: true, //五大债券
      isFiveBonds: false,
      fileList: [],
      showDialog: false,
      showLead: false,
      uploading: false,
      loading: false,
      // 表头
      columns: [
        {
          title: '名称',
          align: 'center',
          dataIndex: 'name',
          ellipsis: true,
          width: 300
        },
        {
          title: '产品代码',
          align: 'center',
          dataIndex: 'fundCode',
          width: 100
        },
        {
          title: '报表开始时间',
          align: 'center',
          width: 200,
          dataIndex: 'beginDate'
        },
        {
          title: '报表结束时间',
          align: 'center',
          width: 200,
          dataIndex: 'endDate'
        },
        {
          title: '理由',
          align: 'center',
          width: 150,
          dataIndex: 'reason'
        },
        {
          title: '是否发布',
          align: 'center',
          width: 150,
          scopedSlots: {
            customRender: 'publishStatus'
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 350,
          fixed: 'right',

          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        publish: process.env.VUE_APP_CMS_PRODUCT + '/product/jb/publishStatus',
        review: process.env.VUE_APP_CMS_PRODUCT + '/product/jb/checkStatus',
        list: process.env.VUE_APP_CMS_PRODUCT + '/product/jb/list',
        importExcelUrl:
          process.env.VUE_APP_CMS_PRODUCT + '/product/jb/importZip'
      },
      dictOptions: {},
      superFieldList: [],
      selectedRowKeys: [],
      selectionRows: [],
      dataSource: [],
      reason: '',
      examineFlg: 1,
      superQueryParams: '',
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
        recordId: ''
      }
    };
  },
  created() {
    this.getList();
  },

  methods: {
    reviewDetails(record) {
      this.recordId = record.id;
      this.showReview = true;
    },
    //审核
    handalExamine() {
      let params = {
        id: this.recordId,
        status: this.examineFlg,
        reason: this.reason
      };
      postTag(this.url.review, params).then(res => {
        if (res.success) {
          this.showReview = false;
          this.reason = '';
          this.getList(1);
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //发布
    handlePublish(checked, record) {
      postTag(this.url.publish, {
        id: record.id,
        status: checked ? 1 : 0
      }).then(res => {
        if (res.success) {
          this.getList(1);
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    examineFlgChange(e) {
      this.examineFlg = e.target.value;
    },
    //五大债券
    handleFiveBonds(record, type, refName) {
      this.isShowIndex = !this.isShowIndex;
      if (type == 1) {
        this.isFiveBonds = !this.isFiveBonds;
      } else if (type == 2) {
        this.isTenStocks = !this.isTenStocks;
      } else if (type == 3) {
        this.isDistribution = !this.isDistribution;
      } else if (type == 4) {
        this.isPortfolio = !this.isPortfolio;
      }
      this.$nextTick(() => {
        this.$refs[refName].initFundCode(record);
      });
    },
    handelColse(type) {
      this[type] = !this[type];
      this.isShowIndex = !this.isShowIndex;
    },
    // 查询
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = {
        pageSize: that.ipagination.pageSize,
        pageNo: that.ipagination.current,
        name: that.fileName
      };
      that.loading = true;
      getAction(this.url.list, params).then(res => {
        that.loading = false;
        if (res.success) {
          that.dataSource =
            res.result && res.result.records ? res.result.records : [];
          this.dataSource.forEach(item => {
            item.statusFlg = item.publishStatus == 0 ? false : true;
          });
          that.ipagination.total = res.result.total;
        } else {
          that.$message.error(res.message);
        }
      });
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    //添加
    handleAdd() {
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },

    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.fileName = '';
      this.getList(1);
    },

    //分页
    handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      this.ipagination = pagination;
      this.getList();
    },

    // 文件上传
    beforeUpload(file) {
      this.fileList = [file];
      console.log(this.fileList);
      return false;
    },
    // 删除文件
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    upload() {
      let formData = new FormData();
      this.uploading = true;
      formData.set('file', this.fileList[0]);

      uploadAction(this.url.importExcelUrl, formData)
        .then(res => {
          if (res.success) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.uploading = false;
          this.fileList = [];
          this.showDialog = false;
          this.searchQuery();
        });
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
